import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=7b159d6f&scoped=true&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=7b159d6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b159d6f",
  null
  
)

component.options.__file = "TermsAndConditions.vue"
export default component.exports